module.exports = __webpack_public_path__ + "static/media/logo-polyrec.0417c9f3.png";